export default {"src":"/_next/static/media/Glaucoma.583b71ec.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};